import React, { FC } from 'react';

import { formatNumber as format } from '@utils/littery';

import { NumberItem } from './NumberItem';

import styles from './index.module.less';

interface NumberRollingProps {
  /** 注意：只接受string，number会有精度问题 */
  number: string;
  thousandSeparator?: boolean; // 千分位格式
  color?: string;
  fontSize?: number;
  fontFamily?: string;
  className?: string;
  speed?: number; // 相邻数字之间过渡时间间隔 单位ms
}

//   const {
//     number = '0',
//     fontSize = 16,
//     fontFamily = 'DINPro-Medium"',
//     color = '#ccc',
//     speed = 200,
//     className
//   } = props;
//   const spanDom = useRef<HTMLSpanElement>();

//   useEffect(() => {
//     const num = Number(number);
//     if (!spanDom.current) return;
//     spanDom.current.style.transition = `transform ${
//       (num * speed) / 1000
//     }s ease-in-out`;
//     spanDom.current.style.transform = `translateY(-${num * fontSize * 1.5}px)`; // 之所以要*1.5 是为了解决符号展示不全的问题
//   }, [number, fontSize, speed]);

//   const content = useMemo(() => {
//     const num = Number(number);
//     if (isNaN(num)) {
//       return (
//         <span
//           className={styles.separator}
//           style={{
//             fontSize: `${fontSize}px`,
//             fontFamily,
//             color,
//             lineHeight: '1.5'
//           }}
//         >
//           {number}
//         </span>
//       );
//     }
//     return (
//       <span
//         className={styles.numContainer}
//         style={{
//           fontSize: `${fontSize}px`,
//           lineHeight: '1.5',
//           height: `${fontSize * 1.5}px`
//         }}
//       >
//         <span className={styles.numItem} ref={spanDom}>
//           {nums.map((item) => (
//             <span
//               key={item}
//               className={className}
//               style={{
//                 fontSize: `${fontSize}px`,
//                 fontFamily,
//                 color,
//                 lineHeight: '1.5'
//               }}
//             >
//               {item}
//             </span>
//           ))}
//         </span>
//       </span>
//     );
//   }, [number, fontSize, fontFamily, color, className]);

//   return <>{content}</>;
// };

export const NumberRolling: FC<NumberRollingProps> = (props) => {
  const {
    number,
    thousandSeparator = true,
    fontFamily,
    fontSize,
    color,
    className
  } = props;

  const formatNumber = thousandSeparator
    ? format(number).split('')
    : String(number).split('');

  return (
    <div className={styles.container} id="change-in-amount-box">
      {formatNumber.map((item, i) => {
        return (
          <NumberItem
            number={item}
            fontFamily={fontFamily}
            fontSize={fontSize}
            color={color}
            className={className}
            key={i + item}
          />
        );
      })}
    </div>
  );
};
